<template>
	<div v-loading="loading">
		<!-- <label for="" class="code">VIN码</label> -->
    <el-input class="w-650 m-r-10" v-model="key" :placeholder="placeholder" :disabled="disabled" @input="change"></el-input>
    <el-button v-if="!disabled" @click="query">查询</el-button>
    <div>
      <ul class="showDataUl m-t-10">
        <li v-for="(value, key) in api_return_content">
        {{ key }} : {{ value }}
        </li>
      </ul>
    </div>
    <el-dialog ref="dialog" title="请选择" class="interfaceTable">
      <el-table
        :data="tableData"
        style="width: 100%"
        >
        <el-table-column
          label="操作"
          width="80">
          <template scope="scope">
            <el-radio class="radio" v-model="radio" :label="scope.$index"><span style="opacity:0">1</span></el-radio>
          </template>
        </el-table-column>
        <el-table-column type="expand">
          <template scope="props">
            <el-form label-position="left" inline class="demo-table-expand">
              <el-form-item :label="key" v-for="(value, key) in props.row">
                <span>{{value}}</span>
              </el-form-item>
            </el-form>
          </template>
        </el-table-column>
        <el-table-column
          label="简介"
          >
          <template scope="props">
            <ul class="introduction">
              <li v-for = "item in getShowValue(props.row)">{{item}}</li>
            </ul>
          </template>
        </el-table-column>
      </el-table>
      <el-button type="primary" class="m-t-10" size="small" @click="chooseContent">确定</el-button>
    </el-dialog>
	</div>
</template>
<script>
import modelConfig from '../../../../config/modelConfig'
import http from '../../../../assets/js/http'
export default{
  props: ['value', 'title', 'name', 'disabled', 'config', 'rules'],
  data() {
    return {
      key: '',
      api_return_content: {},
      submitData: {},
      tableData: [],
      initTableData: [],
      radio: 0,
      isQuery: false,
      loading: false,
      transferInfo: []
    }
  },
  methods: {
    query() {
      let postData = {
        key: this.key,
        config: this.config
      }
      this.loading = true
      this.apiPost('cms/contents/obtainInterface', postData).then((res) => {
        if (res.code == 200) {
          this.isQuery = true
          this.loading = false
          if (res.data instanceof Array) {
            this.tableData = res.data
            this.openDialog()
          } else {
            this.api_return_content = res.data
            this.submitData = {
              api_return_content: res.data,
              key: this.key
            }
            _(this.config.set_field).forEach((item) => {
              let obj = {}
              obj[item.param] = res.data[item.param]
              obj['name'] = item.fieldname
              this.transferInfo.push(obj)
            })
            this.$emit('transferInfo', this.transferInfo)
            this.change()
          }
        } else {
          _g.toastMsg(this, 'error', res.error)
          this.loading = false
        }
      })
    },
    chooseContent() {
      this.api_return_content = this.tableData[this.radio]
      this.submitData = {
        api_return_content: this.api_return_content,
        key: this.key
      }
      _(this.config.set_field).forEach((item) => {
        let obj = {}
        obj[item.param] = this.api_return_content[item.param]
        obj['name'] = item.fieldname
        this.transferInfo.push(obj)
      })
      this.$emit('transferInfo', this.transferInfo)
      this.closeDialog()
      this.change()
    },
    openDialog() {
      this.$refs.dialog.open()
    },
    closeDialog() {
      this.$refs.dialog.close()
    },
    getShowValue(obj) {
      let newArr = []
      let count = 0
      _(obj).forEach((res, key) => {
        if (count < 5) {
          newArr.push(res)
          count++
        }
      })
      return newArr
    },
    change() {
      if (this.isQuery) {
        this.$emit('input', this.submitData)
      } else {
        this.$emit('input', this.key)
      }
    }
  },
  created() {
    if (this.value != '') {
      this.key = this.value
    }
  },
  mixins: [modelConfig, http]
}
</script>
<style>
	.showDataUl{
    margin: 0;
    padding: 0;
    width: 100%;
  }
  .showDataUl li{
    display: inline-block;
    color: #99a9bf;
    width: 33%;
  }
  .introduction{
    margin: 0;
    padding: 0;
  }
  .introduction li{
    display: inline-block;
    margin-right:15px;
    color: #99a9bf;
  }
  div.interfaceTable .el-dialog--small{
    width: 80%;
  }
  div.interfaceTable .demo-table-expand {
    font-size: 0;
  }
  div.interfaceTable .demo-table-expand label {
    width: 170px;
    color: #99a9bf;
  }
  div.interfaceTable .demo-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
    width: 50%;
  }
  div.interfaceTable .el-form-item__content {
    margin-top: 0px !important;
  }
</style>


// WEBPACK FOOTER //
// honrayInterface.vue?fa44bdb2